import {
  ParticipantEmployeeFragment,
  TrainingListPageCompetencyFragment,
  TrainingListPageDocument,
  TrainingsCategory,
} from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import EmptyState from 'modules/trainings/components/Revamp/EmptyState'
import { TrainingsDataCollection } from 'modules/trainings/components/TrainingsDataCollection'
import { useTrainingsCategories } from 'modules/trainings/hooks/Categories/useTrainingsCategories'

const List = () => {
  const { data, loading: loadingTrainings, error } = useQuery(TrainingListPageDocument)
  const isEmpty = data?.trainings.trainingsConnection?.nodes.length === 0
  const { loading: loadingCategories, categories } = useTrainingsCategories()

  const loading = loadingTrainings || loadingCategories

  useEffect(() => {
    track(trackingEvents.training.openTrainingList)
  }, [])

  return (
    <ResponsivePage.Body
      variant="full"
      showHeader={false}
      authorized={data?.trainings._policies.trainingsAccessManagementSpace.can}
      loading={loading}
      error={error}
    >
      <Content
        isEmpty={isEmpty}
        canCreate={Boolean(data?.trainings._policies.trainingCreate.can)}
        competencies={data?.competencies.competenciesConnection?.nodes ?? []}
        categories={categories}
        employees={data?.employees.employees ?? []}
      />
    </ResponsivePage.Body>
  )
}

function Content({
  isEmpty,
  canCreate,
  competencies,
  categories,
  employees,
}: {
  isEmpty: boolean
  canCreate: boolean
  competencies?: TrainingListPageCompetencyFragment[]
  categories?: TrainingsCategory[]
  employees: ParticipantEmployeeFragment[]
}) {
  if (isEmpty) return <EmptyState canCreate={canCreate} />
  return (
    <TrainingsDataCollection
      canCreate={canCreate}
      competencies={competencies}
      categories={categories}
      employeesData={employees}
    />
  )
}

export default List
